import analytics from '@xto10x/core/lib/analytics';

export default function componentLoader(lazyComponent, attempt = 0) {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch(error => {
        if (attempt >= 2) {
          reject(error);
          analytics.trackError(
            'page_load',
            'goals_app_component_loader_failed',
            `${error?.message ? error?.message : ''}`
          );
          return;
        }
        setTimeout(() => {
          componentLoader(lazyComponent, attempt + 1).then(resolve, reject);
        }, (attempt + 1) * 1500);
      });
  });
}
